<template>
  <div
    @click="setFood"
    class="food-card-component d-flex align-center justify-space-between"
    :class="{ checked }"
  >
    <div class="food-info-section">
      <span class="food-name font-weight-bold">{{ item.menuItem.name }}</span>
      <span v-if="showModification" class="price-info">мод: {{ item.modificationMenuItem.modification.name }}</span>
    </div>
    <div class="buttons-section">
      <v-btn
        v-if="!checked"
        class="button-edit"
        icon
        depressed
        :class="{ 'has-comment': !!item.comment }"
      >
        <font-awesome-icon icon="comment-dots" />
      </v-btn>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'FoodCard',
    props: {
      item: {
        type: Object,
        default: () => ({}),
      },
      checked: Boolean,
    },
    computed: {
      showModification () {
        return !!this.item.modificationMenuItem
      },
    },
    methods: {
      setFood () {
        this.$emit('input', this.item.id)
      },
    },
  }
</script>

<style lang="less" scoped>
.food-card-component {
  margin-bottom: 15px;
  padding: 24px 25px 22px 21px;
  background-color: @color-secondary;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.2s ease;

  &.checked {
    background-color: @color-primary;
    .address-icon-section {
      svg {
        .fill-svg(#ffffff);
      }
    }
    .food-name,
    .price-info {
      color: #ffffff;
    }
  }

  &:last-child {
    margin-bottom: 0;
  }

  .food-info-section {
    flex: 1;

    .food-name {
      display: block;
      font-size: 24px;
      line-height: 21px;
      margin-bottom: 6px;
    }

    .price-info {
      font-size: 16px;
      line-height: 19px;
    }
  }

  .buttons-section {
    height: 50px;
    .button-checked {
      height: 50px;
      width: 50px;
      background-color: #ffffff;

      svg {
        width: 18px;
        height: 18px;
        .fill-svg(@color-primary);
      }
    }

    .button-edit {
      height: 50px;
      width: 50px;
      background-color: #d4ddeb !important;

      &.has-comment {
        background-color: @color-primary !important;
        svg {
          .fill-svg(#ffffff);
        }
      }

      svg {
        width: 18px;
        height: 18px;
        .fill-svg(@color-secondary);
      }

      ::v-deep {
        .v-btn__content {
          text-align: center;
        }
      }
    }
  }
}
</style>
